import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function postFeatureFlags(flags = []) {
  try {
    const { data } = await http.post('/feature-flags/list', {
      flags,
    });

    return data.values;
  } catch (e) {
    logWebHrError({
      message: 'Failed to post feature flags',
      source: 'post-feature-flags',
      metadata: {
        flags,
      },
      error: e,
    });
    throw e;
  }
}
